{
    "Accessibility menu": "Izbornik Pristupačnosti",
    "Close": "Zatvori",
    "Content adjustments": "Prilagodbe Sadržaja",
    "Navigation adjustments": "Prilagodbe Navigacije",
    "Text Align": "Text Align",
    "Align Left": "Poravnaj Lijevo",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Prilagodi Veličinu Fonta",
    "Highlight Title": "Istakni Naslove",
    "Highlight Links": "Istakni Poveznice",
    "Readable Font": "Čitljiv Font",
    "Colour adjustments": "Prilagodbe Boja",
    "Dark Contrast": "Tamni Kontrast",
    "Light Contrast": "Svijetli Kontrast",
    "High Contrast": "Visoki Kontrast",
    "High Saturation": "Visoka Zasićenost",
    "Low Saturation": "Niska Zasićenost",
    "Monochrome": "Jednobojno",
    "Tools": "Alati",
    "Reading Guide": "Vodič Za Čitanje",
    "Big Cursor": "Veliki Kursor",
    "Increase Font Size": "Povećaj Veličinu Fonta",
    "Decrease Font Size": "Smanji Veličinu Fonta",
    "Letter Spacing": "Razmak Između Slova",
    "Line Height": "Visina Linije",
    "Font Weight": "Debljina Fonta",
    "Dyslexia Font": "Font Za Disleksiju",
    "Language": "Jezik",
    "Accessibility widget": "Otvori Izbornik Pristupačnosti",
    "Accessibility Profiles": "Profil Pristupačnosti",
    "Cognitive Disability": "Kognitivni Invaliditet",
    "Seizure Safe": "Sigurno Za Epilepsiju",
    "Accessibility statement": "Izjava O Pristupačnosti",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Zaustavi Animacije",
    "Reset all settings": "Resetiraj postavke",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
